import { isPathMark } from '../../mark';
import { hasContinuousDomain } from '../../scale';
import { getMarkPropOrConfig } from '../common';
import { normalizeInvalidDataMode } from './normalizeInvalidDataMode';
export function getScaleInvalidDataMode(_ref) {
  var _config$scale;
  var markDef = _ref.markDef,
    config = _ref.config,
    scaleChannel = _ref.scaleChannel,
    scaleType = _ref.scaleType,
    isCountAggregate = _ref.isCountAggregate;
  if (!scaleType || !hasContinuousDomain(scaleType) || isCountAggregate) {
    // - Discrete scales can always display null as another category
    // - Count cannot output null values
    return 'always-valid';
  }
  var invalidMode = normalizeInvalidDataMode(getMarkPropOrConfig('invalid', markDef, config), {
    isPath: isPathMark(markDef.type)
  });
  var scaleOutputForInvalid = (_config$scale = config.scale) === null || _config$scale === void 0 || (_config$scale = _config$scale.invalid) === null || _config$scale === void 0 ? void 0 : _config$scale[scaleChannel];
  if (scaleOutputForInvalid !== undefined) {
    // Regardless of the current invalid mode, if the channel has a default value, we consider the field valid.
    return 'show';
  }
  return invalidMode;
}
export function shouldBreakPath(mode) {
  return mode === 'break-paths-filter-domains' || mode === 'break-paths-show-domains';
}